import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Button,
  withStyles,
  WithStyles,
  Grid,
} from "@material-ui/core";

import { DialogType } from "../../../models/Types/DialogType";
import { styles } from "./DialogStyles";
import proximamenteMobile from "../../../assets/images/smartPhone.png";

interface PublicProps {
  dialog: DialogType;
}
type Props = PublicProps & WithStyles<typeof styles>;
const MyDialog: React.FC<Props> = (props: any) => {
  const { dialog, classes } = props;

  const [clicked, setClicked] = React.useState(false);

  const handleContinueClick = () => {
    dialog.acceptClicked();
    setClicked(true);
  };

  React.useEffect(() => {
    if (dialog.show) {
      setClicked(false);
    }
  }, [dialog.show]);

  if (!dialog.show) return null;
  return (
    <Dialog
      open={dialog.show}
      onClose={dialog.cancelClicked}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogContent className={classes.container}>
        <Grid container spacing={1}>
          <Grid
            container
            item
            xs={dialog.hasImage ? 8 : 12}
            direction="column"
            justify="space-between"
          >
            <Grid item>
              <DialogTitle id="alert-dialog-title" className={classes.title}>
                {dialog.title}
              </DialogTitle>
            </Grid>
            <Grid item>
              <DialogContentText
                id="alert-dialog-description"
                className={classes.textContent}
              >
                {dialog.text}
              </DialogContentText>
            </Grid>
            <Grid item justify="center" container>
              <DialogActions
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className={classes.btnContainer}>
                  {!dialog.continuar && !clicked ? (
                    <>
                      <Button
                        onClick={dialog.cancelClicked}
                        className={classes.button}
                        variant="contained"
                      >
                        {dialog.textCancelar ? dialog.textCancelar : "Cancelar"}
                      </Button>
                      <Button
                        onClick={dialog.acceptClicked}
                        className={classes.button}
                        variant="contained"
                      >
                        {dialog.textAceptar ? dialog.textAceptar : "Aceptar"}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        disabled={clicked}
                        className={classes.button}
                        variant="contained"
                        onClick={handleContinueClick}
                      >
                        Continuar
                      </Button>
                    </>
                  )}
                </div>
              </DialogActions>
            </Grid>
          </Grid>

          {dialog.hasImage && (
            <Grid
              item
              xs={4}
              container
              direction="column"
              alignItems="center"
              justify="center"
            >
              <div className={classes.imageContainer}>
                <img
                  src={proximamenteMobile}
                  alt="Imagen ilustrativa"
                  className={classes.image}
                />
              </div>
            </Grid>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(MyDialog) as React.ComponentType<PublicProps>;
